import React, { useState, useMemo } from 'react';
import { string } from 'prop-types';

import useFullFreeshipping from '../hooks/use-full-freeshipping';
import useTimeout from '../../../hooks/use-timeout';
import FullTopEmpty from '../full-shipping-empty-desktop/full-shipping-empty.desktop';
import FullFreeshipping from '../full-shipping-empty/full-shipping';

/**
 * Component FullFreeshippingContainerDesktop
 * @param {Object} props - Props del componente
 * @param {string} [props.disabledByCookie=''] - Indica si el componente está deshabilitado por una cookie
 * @returns {JSX.Element|null} Componente de snackbar de envío gratis para desktop o null si no hay datos
 */

const FullFreeshippingContainerDesktop = ({ disabledByCookie = '' }) => {
  const { currentFullFreeshipping } = useFullFreeshipping();
  const [isOpen, setIsOpen] = useState(false);

  const isDisabled = useMemo(() => disabledByCookie === 'userhide', [disabledByCookie]);

  useTimeout(
    () => {
      setIsOpen(true);
    },
    500,
    !!currentFullFreeshipping,
  );

  if (!currentFullFreeshipping) {
    return null;
  }

  const { progress_bar } = currentFullFreeshipping;
  const shouldShowEmpty = progress_bar?.color === 'neutral' && progress_bar?.percent === 0;

  if (shouldShowEmpty) {
    return isOpen && <FullTopEmpty disabledByCookie={isDisabled} />;
  }

  return <FullFreeshipping location="up" />;
};

FullFreeshippingContainerDesktop.propTypes = {
  disabledByCookie: string,
};

export default React.memo(FullFreeshippingContainerDesktop);
